import clickToCall from './clickToCall';

export default clickToCall;
